import { Secondary, SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './browse-all-cars-card.module.css'
import { Card } from '../../shared/card'

export const BrowseAllCarsCard = () => (
  <Card data-testid="browse-all-cars-card" element="article" isHoverable={true}>
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <SvgIcon name="search" size={41} color="iceBlue" />
        <Text className={styles.description}>
          {'Looking for something different?'}
        </Text>
        <Secondary
          classNames={{ button: styles['button'] }}
          element="a"
          size="small"
          href="/used-cars"
          variant="alternative"
        >
          {'Browse all cars'}
        </Secondary>
      </div>
    </div>
  </Card>
)
